import { Outlet, useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import SurveyConfiguration from 'modules/surveys/components/Configuration/SurveyConfiguration'
import SurveySettings from 'modules/surveys/components/Settings/SurveySettings'
import SurveyShowHeader from 'modules/surveys/components/Show/SurveyShowHeader'
import SurveyShowPageTabs from 'modules/surveys/components/Show/SurveyShowPageTabs'
import { useSurveyShowContext } from 'modules/surveys/pages/Show/hooks'
import type SurveyForm from 'modules/surveys/store/models/Form'

export default function SurveyConfigurationPage() {
  const { employee } = useCurrentSession()
  const { survey, hasSurveyV2, canEditSurvey, loading } = useSurveyShowContext()
  const { form } = useOutletContext<{ form: SurveyForm }>()

  if (!survey) {
    return null
  }

  return (
    <ResponsivePage.Body
      showHeader={false}
      loading={loading}
      error={null}
      authorized={employee?.hasRegularAccess && canEditSurvey}
    >
      <Box gap="s24">
        <SurveyShowHeader survey={survey} canEditSurvey={canEditSurvey} />
        <SurveyShowPageTabs form={survey} canEditSurvey={canEditSurvey} />
      </Box>
      {hasSurveyV2 ? <SurveySettings /> : <SurveyConfiguration form={form} />}
      <Outlet context={{ form }} />
    </ResponsivePage.Body>
  )
}
